import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import { cmsAccount, jsonHeaders, msHeaders } from './NavMenu';
import "./css/DeviceSetupModal.css";

export function DeviceSetupModal({ shown, closeModal }) {
    const [deviceName, setDeviceName] = useState("");
    const [serialNumber, setSerialNumber] = useState("");
    const [model, setModel] = useState("");
    const [deviceId, setDeviceId] = useState("");
    const [registerEnabled, setRegisterEnbaled] = useState(false);

    useEffect(() => {
        if (shown) {
            $('#ds-modal-container').fadeIn(300);
            $('#ds-modal-container').css('display', 'flex');
            $('#ds-modal').css({ "margin-top": "2000px" }).animate({ "margin-top": "0px" }, 300)
        }
    }, [shown]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (cmsAccount) {
                clearInterval(intervalId);
            }
        }, 100);
    }, [])

    function close() {
        closeModal();
        setSerialNumber("");
        setDeviceName("");
        setModel("");
        setDeviceId("");
        $('#ds-modal-container').fadeOut(300);
        $('#ds-modal').css({ "margin-top": "0px" }).animate({ "margin-top": "2000px" }, 300);
    }

    function handleInput(e) {
        let element = e.target.parentNode;
        element.style.border = "2px solid #094EFF";
        element.style.padding = "7px 23px";
    }

    function handleBlur(e) {
        let element = e.target.parentNode;
        element.style.border = "";
        element.style.padding = "";
        if (e.target.id == "serial-number") {
            const sn = e.target.value;
            setSerialNumber(sn);
            var requestOptions = {
                method: 'GET',
                headers: msHeaders,
                redirect: 'follow'
            };
            fetch(`/api/devices/sn/${sn}`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.companyUUID) {
                        alert("Device already exists in your company.");
                        return;
                    }
                    if (!result.id)
                        alert("Device not found.");
                    setDeviceId(result.uuid);
                    setModel(result.model);
                    setRegisterEnbaled(result.id ? true : false);
                })
        }
        else if (e.target.id == "device-name") {
            setDeviceName(e.target.value);
        }
    }

    function register() {
        var requestOptions = {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify({
                name: deviceName,
                sn: serialNumber,
            }),
            redirect: 'follow'
        };
        fetch(`/api/devices/register`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                close();
            })
    }

    return (
        <div className="device-setup-modal-container" id="ds-modal-container" onClick={() => { close() }}>
            <div className="device-setup-modal" id="ds-modal" onClick={(e) => { e.stopPropagation() }}>
                <div className="title">
                    Add Device
                </div>
                <div className="info-set">
                    <div className="info-unit" style={{ gap: "32px" }} >
                        <div className="info-name">
                            Device Name:
                        </div>
                        <div className="text-bar">
                            <input className="text input" id="device-name" placeholder="name your device" required value={deviceName}
                                onClick={(e) => { handleInput(e) }}
                                onChange={(e) => { setDeviceName(e.target.value); }}
                                onBlur={(e) => { handleBlur(e) }}
                            />
                        </div>
                    </div>
                    <div className="info-unit" style={{ gap: "32px" }} >
                        <div className="info-name">
                            Serial Number:
                        </div>
                        <div className="text-bar">
                            <input className="text input" id="serial-number" placeholder="Enter the SN on the device rating lable" value={serialNumber}
                                onClick={(e) => { handleInput(e) }}
                                onChange={(e) => { setSerialNumber(e.target.value); }}
                                onBlur={(e) => { handleBlur(e) }}
                            />
                        </div>
                    </div>
                    <div className="info-unit" style={{ gap: "32px" }} >
                        <div className="info-name">
                            Model Name:
                        </div>
                        <div className="selector"
                            onClick={(e) => {
                                e.stopPropagation();
                            }}>
                            <div className="text" id="model-text" style={{ width: "544px" }} >
                                {model}
                            </div>
                        </div>
                    </div>
                    <div className="info-unit" style={{ gap: "32px" }}>
                        <div className="info-name">
                            Device UUID:
                        </div>
                        <div className="selector">
                            <div className="text" id="ort-text" style={{ width: "100%" }} >
                                {deviceId}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom-bar">
                    <button
                        className={`outfit-text ${registerEnabled ? "save-button" : "save-button-disabled"}`}
                        onClick={() => { register() }}
                        disabled={!registerEnabled}>
                        Register
                    </button>
                </div>
            </div>
        </div>
    );
}
